import { render, staticRenderFns } from "./DeviceStaticList.vue?vue&type=template&id=65c0aed9&scoped=true&"
import script from "./DeviceStaticList.vue?vue&type=script&lang=js&"
export * from "./DeviceStaticList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStaticList.vue?vue&type=style&index=0&id=65c0aed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0aed9",
  null
  
)

export default component.exports